import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';

import StockCodeFollowButton from '../../stock-codes/stock-code-follow-button';

const Container = styled.div`
  min-height: ${props => (props.theme.isMobile ? '208px' : '150px')};
  border: 1px solid #E5EAEE;
  border-radius: 8px;
  margin: 0 ${props => (props.theme.isMobile ? '0' : '-26px')};
  cursor: pointer;

  &:hover {
    box-shadow: 0 3px 5px ${props => props.theme.secondaryColor30Transparent};
    transition: transform 0.3s;
    transform: translate(0, -1px);

    [class^="company__Header"] {
      background-color: #788B9B;
    }
  }
`;

const Header = styled.div`
  height: 45px;
  background-color: ${props => (props.theme.secondaryColor)};
  border-radius: 8px 8px 0 0;
  color: ${props => props.theme.bodyBackgroundColor};
  font: 800 20px/110.8% ${props => props.theme.fontFamilyBody};
  padding: 12px 0 12px 20px;
  text-transform: uppercase;
`;

const Body = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 24px 20px 0 20px;

  & > .loading-panel {
    width: 120px;
    margin-top: -10px;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Footer = styled.div`
  margin-top: 30px;
  height: 60px;
  border-top: 1px solid #E5EAEE;

  & > .loading-panel {
    margin: 12px 0 0 20px !important;
    width: 120px !important;
  }
`;

const Title = styled.div`
  color: ${props => props.theme.bodyColor};
  font: 700 20px/110.8% ${props => props.theme.fontFamilyBody};
`;

const SubTitle = styled.div`
  color: ${props => props.theme.secondaryColor};
  font: ${props => props.theme.fontWeightBold} 16px/120% ${props => props.theme.fontFamilyBody};
  margin-top: 8px;
`;

export default function Company({ stockCode }) {
  const { isMobile } = React.useContext(ThemeContext);

  const {
    stockExchange,
    code,
    slug,
    companyName,
    mentionedIn30DaysCount,
    totalMentionedCount,
  } = stockCode;

  const name = `${stockExchange}:${code}`;

  /* eslint-disable no-nested-ternary */
  const mentionedMessage = mentionedIn30DaysCount > 0
    ? `Mentioned ${mentionedIn30DaysCount} times in the last 30 days`
    : totalMentionedCount > 0 ? `Mentioned in ${totalMentionedCount} wires`
      : "This company hasn't been discussed yet";
  /* eslint-enable no-nested-ternary */

  const goToProductPage = e => {
    e && e.preventDefault();
    window.location = `/stock_codes/${slug}`;
  };

  return (
    <Container onClick={goToProductPage}>
      <Header>{name}</Header>
      <Body>
        <TitleContainer>
          <Title>{companyName}</Title>
          <SubTitle>{mentionedMessage}</SubTitle>
        </TitleContainer>
        {!isMobile && <StockCodeFollowButton stockCode={stockCode} />}
      </Body>
      {isMobile && (
        <Footer>
          <StockCodeFollowButton stockCode={stockCode} />
        </Footer>
      )}
    </Container>
  );
}

Company.propTypes = {
  stockCode: PropTypes.shape({
    stockExchange: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    companyName: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    isStockCodeFollowedByCurrentUser: PropTypes.bool.isRequired,
    mentionedIn30DaysCount: PropTypes.number.isRequired,
    totalMentionedCount: PropTypes.number.isRequired,
  }).isRequired,
};
